import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppDataProvider } from './contexts/AppDataContext';
import Layout from './components/layout/Layout';

import Dashboard from './pages/Dashboard';

// Pages pour l'école de formation
import CoursesPage from './pages/courses/CoursesPage';
import GroupsPage from './pages/groups/GroupsPage';
import StudentsPage from './pages/students/StudentsPage';
import TrainersPage from './pages/trainers/TrainersPage';
import SessionsPage from './pages/sessions/SessionsPage';
import CertificationsPage from './pages/certifications/CertificationsPage';
import SchedulePage from './pages/schedule/SchedulePage';
import ClassroomsPage from './pages/classrooms/ClassroomsPage';
import PaymentsPage from './pages/payments/PaymentsPage';

import BenefitsPage from './pages/benefits/BenefitsPage';
import ReportsPage from './pages/reports/ReportsPage';
import SettingsPage from './pages/settings/SettingsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <AppDataProvider>
              <div className="min-h-screen bg-slate-100 text-slate-900 antialiased dark:bg-ink-950 dark:text-slate-50">
                <Routes>
                  {/* Redirect from root and /login to dashboard */}
                  <Route path="/login" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  
                  <Route path="/" element={<Layout />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/courses/*" element={<CoursesPage />} />
                    <Route path="/groups/*" element={<GroupsPage />} />
                    <Route path="/students/*" element={<StudentsPage />} />
                    <Route path="/trainers/*" element={<TrainersPage />} />
                    <Route path="/sessions/*" element={<SessionsPage />} />
                    <Route path="/certifications/*" element={<CertificationsPage />} />
                    <Route path="/schedule/*" element={<SchedulePage />} />
                    <Route path="/classrooms/*" element={<ClassroomsPage />} />
                    <Route path="/payments/*" element={<PaymentsPage />} />
                    <Route path="/benefits/*" element={<BenefitsPage />} />
                    <Route path="/reports/*" element={<ReportsPage />} />
                    <Route path="/settings/*" element={<SettingsPage />} />
                  </Route>
                </Routes>
                <Toaster
                  position="top-right"
                  toastOptions={{
                    duration: 4000,
                    className:
                      '!rounded-xl !border !border-slate-200 !bg-white !text-slate-900 !shadow-lg dark:!border-slate-700 dark:!bg-slate-900 dark:!text-slate-900 dark:text-slate-50',
                  }}
                />
              </div>
            </AppDataProvider>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;